import { render, staticRenderFns } from "./sleep.vue?vue&type=template&id=7aaecac6&scoped=true&"
import script from "./sleep.vue?vue&type=script&lang=js&"
export * from "./sleep.vue?vue&type=script&lang=js&"
import style0 from "./sleep.vue?vue&type=style&index=0&id=7aaecac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaecac6",
  null
  
)

export default component.exports